import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ResourceService } from '../../../services/resource.service';
import { forkJoin, Observable, Subject } from 'rxjs';
import { ILeaveComponent } from 'src/app/services/leave-guard.service';
import { takeUntil, finalize, tap } from 'rxjs/operators';
import { customCurrencyPipe, percentagePipe } from '../../../utils/pipes';
import { HelpersService } from '../../../services/helpers.service';
import { DefaultService } from 'src/app/utils/api';

@Component({
    selector: 'app-project-modal',
    templateUrl: './project-modal.component.html',
    styleUrls: ['./project-modal.component.scss'],
    standalone: false
})
export class ProjectModalComponent implements OnInit {
    @Input() id?: any;
    @Input() editMode?: any;
    @Output() created = new EventEmitter();
    @Output() updated = new EventEmitter();

    project: any = null;
    pages: { code: any; name: any; notify?: boolean }[];
    form: any;
    popoverHelper: any = null;
    validation: any = {};
    changes: boolean = false;
    clientARR: any[];
    categoryARR: any[];

    ready: boolean = false;
    resourcesReady: boolean = false;
    loading: boolean = false;
    saving: boolean;
    actionId = null;
    submitting: boolean = false;

    formSTR: any = {};

    onDestroy$: Subject<void> = new Subject<void>();

    constructor(
        public ActiveModal: NgbActiveModal,
        public ResourceService: ResourceService,
        private percentagePipe: percentagePipe,
        private customCurrencyPipe: customCurrencyPipe,
        private DefaultService: DefaultService,
        public HelpersService: HelpersService
    ) { }

    ngOnInit(): void {
        // edit or create
        if (this.id) {
            this.getProject();
        } else {
            this.project = {};
            this.ready = true;
        }
        // fetch resources
        this.initResources();
    }

    getProject() {
        this.loading = true;
        this.DefaultService.projectsGetProjects(null, null, null, null, this.id)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((next: any) => {
                this.project = next.data[0];
                this.resetForm();
                this.ready = true;
                this.loading = false;
            });
    }

    formChange() {
        this.changes = true;
    }

    resetForm() {
        this.formSTR = { ...this.project };
    }

    createUpdateDiscount() {
        const FORM = { ...this.formSTR };
        if (FORM.type != 'unique') {
            delete FORM.uniqueAmount;
        }
        if (FORM.discountOn != 'category') {
            delete FORM.category;
        }
        if (FORM.discountOn != 'product') {
            delete FORM.product;
        }
        if (this.id) {
            FORM.id = this.id;
        }
        this.saving = true;
        this.submitting = true;
        this.DefaultService.projectsInsertOrUpdateProject(FORM)
            .pipe(
                finalize(() => {
                    this.saving = false;
                    this.submitting = false;
                })
            )
            .subscribe(
                (next) => {
                    this.validation = {};
                    this.updated.emit(this.project);
                    this.changes = false;
                    this.ActiveModal.dismiss();
                },
                (error) => {
                    this.validation = error.error.details;
                }
            );
    }

    initResources() {
        const observables$: Observable<any>[] = [];

        const productsObservable$ = this.DefaultService.clientsGetClients().pipe(
            tap((next: any) => {
                this.clientARR = [
                    { title: 'Selecteer...', value: null },
                    ...next.data.map((i) => {
                        return {
                            title: i.name,
                            value: i.id
                        };
                    })
                ];
            })
        );
        observables$.push(productsObservable$);

        forkJoin(observables$).subscribe((next) => {
            this.resourcesReady = true;
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    canExit(): boolean {
        if (!this.changes || confirm('You have unsaved changes, are you sure you want to leave?')) {
            this.changes = false;
            return true;
        } else {
            return false;
        }
    }

    @HostListener('window:beforeunload', ['$event'])
    beforeUnloadHandler(event: Event) {
        if (this.changes) return false;
    }
}
